var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResursiAlatka(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#6E5DD8;}\r\n\t.st1{fill:#FA7268;}\r\n\t.st2{fill:#AA6276;}\r\n\t.st3{fill:#159497;}\r\n\t.st4{fill:none;stroke:#6E5DD8;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st5{fill:none;stroke:#159497;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st6{fill:#231F20;}\r\n\t.st7{fill:none;stroke:#FA7268;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st8{fill:#FFFFFF;stroke:#231F20;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st9{fill:#FFFFFF;stroke:#FA7268;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st10{fill:#6E5DD8;stroke:#FA7268;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st11{fill:none;stroke:#231F20;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st12{fill:none;stroke:#AA6276;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st13{fill:#FFFFFF;}\r\n\t.st14{fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st15{fill:none;stroke:#000000;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st16{fill:#FFFFFF;stroke:#6E5DD8;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st17{fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st18{fill:#FFFFFF;stroke:#159497;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st19{fill:#FFFFFF;stroke:#AA6276;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st20{fill:#FA7268;stroke:#231F20;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st21{fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st22{fill:#FA7267;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M166.59,74.64C73.98,127.08,13.39,273.18,91.24,361.9c25.26,28.78,60.83,47.49,98.18,55.92 c39.76,8.97,82.25,6.62,120.18-8.32c56.56-22.27,95.46-72.15,116.86-127.7c10.29-26.7,16.59-55.29,15.04-83.87 c-1.55-28.57-11.36-57.16-30.3-78.61c-21.18-24-52.6-37.64-84.45-40.88s-64.12,3.3-94.02,14.72 c-26.28,10.04-51.61,24.27-70.04,45.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "386.76,53.05 395.7,37.56 377.82,37.56  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.98,
    y: 443.7,
    transform: "matrix(-1 -4.520130e-11 4.520130e-11 -1 674.7866 904.2172)",
    className: "st1",
    width: 16.82,
    height: 16.82
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 112.05,
    cy: 289.6,
    r: 8.83
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M442.7,448.1l36.21-50.29c3.11-4.32,2.13-10.34-2.19-13.45L70.75,92c-4.32-3.11-10.34-2.13-13.45,2.19 l-36.21,50.29c-3.11,4.32-2.13,10.34,2.19,13.45l405.98,292.36C433.57,453.4,439.59,452.42,442.7,448.1z M426.54,398.28 c3.04-4.23,8.94-5.19,13.17-2.14s5.19,8.94,2.14,13.17c-3.04,4.23-8.94,5.19-13.17,2.14C424.46,408.4,423.5,402.51,426.54,398.28z "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 441,
    y1: 358.64,
    x2: 430.55,
    y2: 373.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 435.58,
    y1: 354.73,
    x2: 425.13,
    y2: 369.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 430.16,
    y1: 350.83,
    x2: 419.71,
    y2: 365.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 424.74,
    y1: 346.93,
    x2: 414.29,
    y2: 361.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 419.32,
    y1: 343.02,
    x2: 408.86,
    y2: 357.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 413.9,
    y1: 339.12,
    x2: 403.44,
    y2: 353.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 408.48,
    y1: 335.21,
    x2: 398.02,
    y2: 349.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 403.06,
    y1: 331.31,
    x2: 392.6,
    y2: 345.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 397.64,
    y1: 327.41,
    x2: 387.18,
    y2: 341.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 392.21,
    y1: 323.5,
    x2: 381.76,
    y2: 338.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 386.79,
    y1: 319.6,
    x2: 376.34,
    y2: 334.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 381.37,
    y1: 315.7,
    x2: 370.92,
    y2: 330.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 375.95,
    y1: 311.79,
    x2: 365.5,
    y2: 326.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 370.53,
    y1: 307.89,
    x2: 360.08,
    y2: 322.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 365.11,
    y1: 303.98,
    x2: 354.66,
    y2: 318.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 359.69,
    y1: 300.08,
    x2: 349.24,
    y2: 314.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 354.27,
    y1: 296.18,
    x2: 343.82,
    y2: 310.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 348.85,
    y1: 292.27,
    x2: 338.4,
    y2: 306.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 343.43,
    y1: 288.37,
    x2: 332.97,
    y2: 302.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 338.01,
    y1: 284.47,
    x2: 327.55,
    y2: 298.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 332.59,
    y1: 280.56,
    x2: 322.13,
    y2: 295.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 327.17,
    y1: 276.66,
    x2: 316.71,
    y2: 291.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 321.75,
    y1: 272.76,
    x2: 311.29,
    y2: 287.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 316.32,
    y1: 268.85,
    x2: 305.87,
    y2: 283.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 310.9,
    y1: 264.95,
    x2: 300.45,
    y2: 279.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 305.48,
    y1: 261.04,
    x2: 295.03,
    y2: 275.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 300.06,
    y1: 257.14,
    x2: 289.61,
    y2: 271.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 294.64,
    y1: 253.24,
    x2: 284.19,
    y2: 267.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 289.22,
    y1: 249.33,
    x2: 278.77,
    y2: 263.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 283.8,
    y1: 245.43,
    x2: 273.35,
    y2: 259.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 278.38,
    y1: 241.53,
    x2: 267.93,
    y2: 256.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 272.96,
    y1: 237.62,
    x2: 262.51,
    y2: 252.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 267.54,
    y1: 233.72,
    x2: 257.08,
    y2: 248.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 262.12,
    y1: 229.81,
    x2: 251.66,
    y2: 244.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 256.7,
    y1: 225.91,
    x2: 246.24,
    y2: 240.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 251.28,
    y1: 222.01,
    x2: 240.82,
    y2: 236.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 245.86,
    y1: 218.1,
    x2: 235.4,
    y2: 232.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 240.43,
    y1: 214.2,
    x2: 229.98,
    y2: 228.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 235.01,
    y1: 210.3,
    x2: 224.56,
    y2: 224.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 229.59,
    y1: 206.39,
    x2: 219.14,
    y2: 220.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 224.17,
    y1: 202.49,
    x2: 213.72,
    y2: 217
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 218.75,
    y1: 198.59,
    x2: 208.3,
    y2: 213.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 213.33,
    y1: 194.68,
    x2: 202.88,
    y2: 209.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 207.91,
    y1: 190.78,
    x2: 197.46,
    y2: 205.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 202.49,
    y1: 186.87,
    x2: 192.04,
    y2: 201.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 197.07,
    y1: 182.97,
    x2: 186.62,
    y2: 197.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 191.65,
    y1: 179.07,
    x2: 181.19,
    y2: 193.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 186.23,
    y1: 175.16,
    x2: 175.77,
    y2: 189.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 180.81,
    y1: 171.26,
    x2: 170.35,
    y2: 185.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 175.39,
    y1: 167.36,
    x2: 164.93,
    y2: 181.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 169.97,
    y1: 163.45,
    x2: 159.51,
    y2: 177.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 164.54,
    y1: 159.55,
    x2: 154.09,
    y2: 174.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 159.12,
    y1: 155.64,
    x2: 148.67,
    y2: 170.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 153.7,
    y1: 151.74,
    x2: 143.25,
    y2: 166.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 148.28,
    y1: 147.84,
    x2: 137.83,
    y2: 162.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 142.86,
    y1: 143.93,
    x2: 132.41,
    y2: 158.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 137.44,
    y1: 140.03,
    x2: 126.99,
    y2: 154.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 132.02,
    y1: 136.13,
    x2: 121.57,
    y2: 150.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 126.6,
    y1: 132.22,
    x2: 116.15,
    y2: 146.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 121.18,
    y1: 128.32,
    x2: 110.73,
    y2: 142.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 115.76,
    y1: 124.42,
    x2: 105.31,
    y2: 138.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 110.34,
    y1: 120.51,
    x2: 99.88,
    y2: 135.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 104.92,
    y1: 116.61,
    x2: 94.46,
    y2: 131.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 99.5,
    y1: 112.7,
    x2: 89.04,
    y2: 127.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 94.08,
    y1: 108.8,
    x2: 83.62,
    y2: 123.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 88.66,
    y1: 104.9,
    x2: 78.2,
    y2: 119.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 83.23,
    y1: 100.99,
    x2: 72.78,
    y2: 115.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 77.81,
    y1: 97.09,
    x2: 67.36,
    y2: 111.61
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "256.89,82.92 259.77,40.23 230.24,38.29 227.5,80.97 232.07,108.63 223.9,242 240.45,243.08  248.62,109.75  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M204.76,455.67l28.33,1.87c15.23,1,28.37-10.53,29.39-25.75l7.29-111.04c0.5-8-5.01-13.82-7.54-20.8 c-3.09-8.53,2.36-36.19,2.36-36.19c0.78-11.98-8.3-22.34-20.26-23.13l-22.32-1.46c-11.99-0.8-22.34,8.29-23.13,20.26 c0,0,1.79,28.13-2.38,36.2c-3.41,6.6-9.68,11.64-10.19,19.64L179,426.3C178,441.52,189.52,454.68,204.76,455.67z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 222.69,
    y: 70.14,
    transform: "matrix(0.6858 0.7278 -0.7278 0.6858 279.0297 -92.9191)",
    className: "st0",
    width: 48.87,
    height: 413.12
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M429.38,95.99l-48.68,21.27l33.52,35.57l24.12-47.33C441.3,99.69,435.35,93.38,429.38,95.99z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.86,112.33l9.16-17.97c1.05-2.06-1.06-4.3-3.18-3.38l-18.49,8.08L434.86,112.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M68.89,450.99l-6.34-6.73c-7.51-7.96-7.13-20.51,0.83-28.01l16.65-15.69l33.52,35.57l-16.65,15.69 C88.94,459.32,76.4,458.95,68.89,450.99z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 391.66,
    y1: 128.88,
    x2: 90.99,
    y2: 412.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 402.61,
    y1: 140.51,
    x2: 101.95,
    y2: 423.82
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResursiAlatka);
export default __webpack_public_path__ + "static/media/Resursi-alatka.44da8c35a84a766841b8b36f0bf66dcf.svg";
export { ForwardRef as ReactComponent };